import { FooterComponent } from './footer/footer.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { SideNavSearchComponent } from './side-nav-search/side-nav-search.component';
import { TopNavComponent } from './top-nav/top-nav.component';

export const containers = [TopNavComponent, SideNavComponent, FooterComponent,SideNavSearchComponent];

export * from './top-nav/top-nav.component';
export * from './side-nav/side-nav.component';
export * from './side-nav-search/side-nav-search.component';
export * from './footer/footer.component';
